import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Folder as ProjectsIcon,
  Timeline as AnalyticsIcon,
  Person as PersonIcon,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { theme as appTheme } from '../../styles/theme';

const MobileBottomNav = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  // Don't show on desktop or on project-specific pages
  const isProjectPage = location.pathname.includes('/projects/') && location.pathname.split('/').length > 4;

  if (!isMobile || isProjectPage) {
    return null;
  }

  // Determine current value based on path
  const getCurrentValue = () => {
    if (location.pathname.includes('/dashboard')) return 0;
    if (location.pathname.includes('/projects')) return 1;
    if (location.pathname.includes('/analytics')) return 2;
    if (location.pathname.includes('/profile')) return 3;
    return 0;
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        background: `${appTheme.colors.surface950}f0`,
        backdropFilter: 'blur(24px)',
        borderTop: `1px solid ${appTheme.colors.borderSubtle}`,
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.4)',
        pb: 'env(safe-area-inset-bottom)',
      }}
      elevation={0}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={(event, newValue) => {
          switch (newValue) {
            case 0: navigate('/app/dashboard'); break;
            case 1: navigate('/app/projects'); break;
            case 2: navigate('/app/analytics'); break;
            case 3: if (onMenuClick) onMenuClick('profile'); break;
            case 4: if (onMenuClick) onMenuClick('menu'); break;
            default: break;
          }
        }}
        showLabels
        sx={{
          height: 60,
          background: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            color: appTheme.colors.textDim,
            minWidth: 56,
            py: 1,
            transition: 'color 0.15s ease',
            '&.Mui-selected': {
              color: appTheme.colors.primary,
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 600,
              },
            },
            '& .MuiSvgIcon-root': {
              fontSize: '1.3rem',
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.7rem',
              fontWeight: 500,
              marginTop: 0.25,
            },
          },
        }}
      >
        <BottomNavigationAction label="Dashboard" icon={<DashboardIcon />} />
        <BottomNavigationAction label="Projects" icon={<ProjectsIcon />} />
        <BottomNavigationAction label="Analytics" icon={<AnalyticsIcon />} />
        <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
        <BottomNavigationAction label="Menu" icon={<MenuIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
